import { RawUserPersonalInfoModel } from "../user_personal_info_model.js";

class RawAdminUserAddressInfoModel extends RawUserPersonalInfoModel {

  formFieldsWhitelist(item=undefined) {
    return ["address"]
  }

}
const AdminUserAddressInfoModel = new RawAdminUserAddressInfoModel();

export { RawAdminUserAddressInfoModel, AdminUserAddressInfoModel }
